<template>
  <div class="search">
    <div class="search-row container">
      <ul class="search-keyword" data-aos="fade-left" data-aos-duration="1000">
        搜索关键词：
        <li><a href="javascript:void(0)">中国水利报</a></li>
        <li><a href="javascript:void(0)">绿色水电</a></li>
        <li><a href="javascript:void(0)">ENT(P)-16H</a></li>
        <li><a href="javascript:void(0)">恩莱吉</a></li>
      </ul>
      <div class="search-box"  data-aos="fade-right" data-aos-duration="1000">
        <el-input
            v-model="searchKey"
            placeholder="请输入内容"
            clearable>
        </el-input>
        <button @click="pushNewsView"><i class="el-icon-search"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      searchKey: ''
    }
  },
  methods: {
    pushNewsView() {
      if (this.searchKey) {
        this.$router.push({name: 'news', params: {searchKey: this.searchKey}})
      } else {
        this.$message({showClose: true, message: "请输入关键词！", type: "warning"})
      }
    }
  }
}
</script>

<style scoped lang="less">
.search {
  background-color: #F7F7F7;

  .search-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 90px;

    .search-keyword {
      display: flex;
      justify-content: left;
      font-size: 14px;
      color: black;

      li {
        margin: 0 10px;

        a {
          color: #8F8F8F;
        }
      }
    }
  }
}
</style>